
import { defineComponent } from "vue";
import api, { CorrelationList, Correlation, RequestPaging, PageBounding, RequestSort }  from "../../api/backend-api";
import { getHumanDate } from "../../util/luxonDateHelpers"
import { getSkipParamForPage, getPageBounding } from "../../util/paginationHelpers";
import { AxiosError } from "axios";

interface State {
  msg: string;
  backendResponse: CorrelationList;
  requestFilter: Correlation;
  requestPaging: RequestPaging;
  requestSorting: RequestSort;
  pageBounds: PageBounding[];
  errors: AxiosError[];
  filterOptions: Record<string, unknown>;
}

export default defineComponent({
  name: "ReceiverCorrelation",
  mounted() {
    this.$nextTick(() => {
      this.getList();
    });
  },

  data: (): State => {
    const correlation_list = { count: 0 } as CorrelationList;
    const correlation_struct = { } as Correlation;
    const paging_struct = { Limit: 20, Skip: 0, Options: [ 20, 50, 100 ] } as RequestPaging;
    const sort_struct = { Pattern: '-id' } as RequestSort;
    const filter_options = {
      'Status': [
        'received',
        'unsupported',
        'converted',
        'delivered',
        'processing',
        'failed'
      ]
    };
    return {
      msg: "Receiver Correlation Events",
      backendResponse: correlation_list,
      requestFilter: correlation_struct,
      requestPaging: paging_struct,
      requestSorting: sort_struct,
      filterOptions: filter_options,
      pageBounds: [],
      errors: [],
    };
  },
  methods: {
    getSkipParamForPage,
    getPageBounding,
    getHumanDate,
    setPage(command: string|number) {
      this.requestPaging.Skip = getSkipParamForPage(command, this.requestPaging.Skip, this.requestPaging.Limit);
      this.getList();
    },
    clearFiltersAndRefresh() {
      const filter_struct = { } as Correlation;
      this.requestFilter = filter_struct;
      this.getList()
    },
    getList() {
      this.backendResponse.items = [];
      const request_params = api.createRequestParams(this.requestFilter, this.requestPaging, this.requestSorting)
      api
        .getCorrelationList(request_params)
        .then((response) => {
          this.backendResponse = response.data;
          this.pageBounds = this.getPageBounding(this.backendResponse.count, this.requestPaging.Limit, this.requestPaging.Skip)
        })
        .catch((error: AxiosError) => {
          this.errors.push(error);
        });
    },
  },
});
